var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup175(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_175",
    "data-name": "Group 175",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.338,
    height: 25,
    viewBox: "0 0 28.338 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3406",
    "data-name": "Path 3406",
    d: "M-585.941,160.774a10.083,10.083,0,0,1,4.17,1.849,10.27,10.27,0,0,1,.677,15.927.98.98,0,0,0-.364.834c.018.874.016,1.749-.012,2.622a1.928,1.928,0,0,1-.233.593,1.841,1.841,0,0,1-.561-.3c-.559-.632-1.087-1.292-1.63-1.946a10.419,10.419,0,0,1-8.991-.467,11.928,11.928,0,0,0,8.708-7.677A11.8,11.8,0,0,0-585.941,160.774Z",
    transform: "translate(605.971 -157.599)",
    fill: "#9f9f9f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3407",
    "data-name": "Path 3407",
    d: "M-743.836,143.819a5.931,5.931,0,0,0-.045-1.888c-.191-.537-.756-.939-1.149-1.407a10.54,10.54,0,0,1,5.86-17.017,10.552,10.552,0,0,1,12.627,8.576,10.55,10.55,0,0,1-8.334,12.041,10.11,10.11,0,0,1-5.3-.317.489.489,0,0,0-.638.192c-.542.686-1.1,1.355-1.656,2.033a.758.758,0,0,1-.869.357.748.748,0,0,1-.5-.836c0-.578,0-1.156,0-1.735Zm1.4-.216c.084-.018.121-.015.134-.031q.407-.486.81-.977c.422-.513.587-.558,1.2-.321a9.161,9.161,0,0,0,4.563.547,9.131,9.131,0,0,0,7.837-10.2,9.1,9.1,0,0,0-10.435-7.82,8.68,8.68,0,0,0-7.36,6.554,8.733,8.733,0,0,0,2.839,9.361,1.1,1.1,0,0,1,.42.913C-742.45,142.28-742.434,142.936-742.434,143.6Z",
    transform: "translate(747.472 -123.265)",
    fill: "#9f9f9f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3408",
    "data-name": "Path 3408",
    d: "M-637.507,234.7a1.344,1.344,0,0,1-1.35-1.33,1.343,1.343,0,0,1,1.329-1.311,1.34,1.34,0,0,1,1.348,1.332A1.337,1.337,0,0,1-637.507,234.7Z",
    transform: "translate(648.052 -222.853)",
    fill: "#9f9f9f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3409",
    "data-name": "Path 3409",
    d: "M-578.7,233.41a1.308,1.308,0,0,1-1.326,1.3,1.3,1.3,0,0,1-1.32-1.343,1.3,1.3,0,0,1,1.323-1.3A1.311,1.311,0,0,1-578.7,233.41Z",
    transform: "translate(595.405 -222.856)",
    fill: "#9f9f9f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3410",
    "data-name": "Path 3410",
    d: "M-694.676,234.708a1.314,1.314,0,0,1-1.317-1.309,1.324,1.324,0,0,1,1.339-1.332,1.317,1.317,0,0,1,1.318,1.311A1.315,1.315,0,0,1-694.676,234.708Z",
    transform: "translate(700.351 -222.857)",
    fill: "#9f9f9f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup175);
export default __webpack_public_path__ + "static/media/Group 175.c5bf12843cd145d2ec491e9b45733cd8.svg";
export { ForwardRef as ReactComponent };